import { all, takeLatest } from 'redux-saga/effects';
import {
  checkCPAndSetZones,
  setReadNotificationsSaga,
} from '@gc-npm/sagas.main-saga';
import {
  initAnchorModalListener,
  addModal,
} from '@gc-npm/sagas.modals-saga';
import { types as mainActions } from '@gc-npm/reducers.main-reducer';
import { types as modalsAnchorActions } from '@gc-npm/reducers.modals-reducer';
import { types as clientActions } from '@/reducers/client';
import { types as modulesActions } from '@/reducers/modules';
import { types as uiActions } from '@/reducers/ui';
import { types as cartActions } from '@/reducers/cart';
import { types as devicesActions } from '@/reducers/devices';
import { types as recomendatorActions } from '@/reducers/recomendator';

import { selectModules, initModules } from '@/sagas/modules';
import {
  sendTaponMetrics,
  initializeConfig,
  showNotification,
  sendRetentionPromo,
  navigate2Login,
  navigate2Url,
  navigate2PurchaseProcess,
  sendOrder2BackOffice,
  getPermanenceFromModulos,
  sendPubSub,
} from '@/sagas/ui';
import {
  getLoginType,
  getMyData,
  getMyR2R,
  getRetention,
} from '@/sagas/client';
import { purchase } from '@/sagas/cart';
import { getDevices } from '@/sagas/devices';
import { selectRecomendator, recomendPackages } from '@/sagas/recomendator';

import autonomosListeners from './autonomos';

function* rootSaga() {
  yield all([
    /* BASICS */
    takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),

    // ANCHOR MODAL
    takeLatest(
      modalsAnchorActions.INIT_ANCHOR_MODAL_LISTENER,
      initAnchorModalListener,
    ),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    // notifications
    takeLatest(
      mainActions.SET_READ_NOTIFICATIONS_INIT,
      setReadNotificationsSaga,
    ),
    ...autonomosListeners,
    // own
    takeLatest(devicesActions.GET_DEVICES, getDevices),
    takeLatest(modulesActions.SELECT_MODULES, selectModules),
    takeLatest(modulesActions.SELECT_MODULES_URL, selectModules),
    takeLatest(modulesActions.INIT_MODULES, initModules),
    takeLatest(clientActions.GET_LOGIN_TYPE, getLoginType), // TODO necesario¿?
    takeLatest(clientActions.GET_MY_DATA, getMyData),
    takeLatest(clientActions.GET_MY_R2R, getMyR2R),
    takeLatest(clientActions.GET_RETENTION, getRetention),
    takeLatest(uiActions.INITIALIZE_CONFIG, initializeConfig),
    takeLatest(uiActions.SET_TAPON, sendTaponMetrics),
    takeLatest(uiActions.SET_NOTIFICATION, showNotification),
    takeLatest(uiActions.SEND_RETENTION_PROMO, sendRetentionPromo),
    takeLatest(uiActions.NAVIGATE_2_PURCHASE_PROCESS, navigate2PurchaseProcess),
    takeLatest(uiActions.NAVIGATE_2_LOGIN, navigate2Login),
    takeLatest(uiActions.NAVIGATE_2_URL, navigate2Url),
    takeLatest(uiActions.SEND_BACKOFFICE, sendOrder2BackOffice),
    takeLatest(uiActions.GET_PERMANENCE, getPermanenceFromModulos),
    takeLatest(uiActions.SEND_PUSSUB, sendPubSub),
    takeLatest(cartActions.PURCHASE, purchase),
    takeLatest(recomendatorActions.SELECT_RECOMENDATOR, selectRecomendator),
    takeLatest(recomendatorActions.RECOMEND_PACKAGES, recomendPackages),
  ]);
}

export default rootSaga;
